import { useLanguage } from '@/hooks/useLanguage';
import { tx as translateInterfaceText } from '@/utils/i18n';

import React from 'react';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

interface RegionalHeaderProps {
  title?: string;
  description?: string;
}

export const RegionalHeader: React.FC<RegionalHeaderProps> = ({
  title = translateInterfaceText("Análise de Locais"),
  description = translateInterfaceText("Entenda de onde vem sua audiência e como ela se comporta")
}) => {
  useLanguage();
  return null;
};
